<template>
    <div
        class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
    >
        <div class="max-w-md w-full space-y-8">
            <div>
                <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Admin Sign in
                </h2>
            </div>
            <p v-if="error" class="shake text-red-800 bg-red-50 py-2 px-4 font-bold">{{ error }}</p>
            <div class="space-y-2 pb-12">
                <label class="flex flex-col">
                    <span>Email</span>
                    <input
                        class="px-4 py-2 border border-gray-200 rounded"
                        v-model="email"
                        type="email"
                        placeholder="email@email.com"
                    />
                </label>
                <label class="flex flex-col">
                    <span>Password</span>
                    <input
                        class="px-4 py-2 border border-gray-200 rounded"
                        v-model="password"
                        type="password"
                    />
                </label>
                <button
                    @click.prevent="loginEmail"
                    :disabled="loading"
                    type="submit"
                    class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-900"
                >
                    <span v-if="loading">Loading...</span>
                    <span v-if="!loading">Sign in with Email</span>
                </button>
            </div>
            <form class="mt-8 space-y-6" action="#" method="POST">
                <div>
                    <button
                        :disabled="loading"
                        @click.prevent="loginFB"
                        type="submit"
                        class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                            <!-- Heroicon name: solid/lock-closed -->
                            <svg
                                class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </span>
                        Sign in with Facebook
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import firebase from '../lib/firebase'
export default {
    name: 'login',
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            error: null,
        }
    },
    methods: {
        loginEmail() {
            return this.login(true)
        },
        loginFB() {
            return this.login(false)
        },
        async login(email = false) {
            let user
            try {
                if (email) {
                    this.loading = true
                    const resp = await firebase
                        .auth()
                        .signInWithEmailAndPassword(this.email, this.password)
                    user = resp.user
                } else {
                    const provider = new firebase.auth.FacebookAuthProvider()
                    await firebase.auth().signInWithPopup(provider)
                    user = firebase.auth().currentUser
                }
            } catch (err) {
                this.error = err.message
            }
            this.loading = false

            const idResult = await firebase.auth().currentUser.getIdTokenResult()
            if (!idResult.claims.admin) {
                this.error = 'Unauthorized: you are not an admin'
                return
            }

            const u = {
                name: user.displayName,
                id: user.uid,
            }
            this.$store.commit('setUser', u)
            this.$router.push({ path: '/' })
        },
    },
}
</script>
